module.exports = __webpack_public_path__ + "static/media/circle-vector.f7a79b2b.svg";